"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Model_1 = __importDefault(require("../Model"));
var ContentModel = /** @class */ (function (_super) {
    __extends(ContentModel, _super);
    function ContentModel(content, getters) {
        var _this = _super.call(this, getters) || this;
        _this.id = content.id;
        _this.position = content.position;
        _this.textId = content.textByTextId || content.textId;
        _this.imageId = content.imageByImageId || content.imageId;
        _this.videoId = content.videoByVideoId || content.videoId;
        _this.questionId = content.questionByQuestionId || content.questionId;
        _this.solutionId = content.solutionBySolutionId || content.solutionId;
        _this.articleId = content.articleByArticleId || content.articleId;
        _this.assertionId = content.assertionByAssertionId || content.assertionId;
        _this.essayReplyId = content.essayReplyByEssayReplyId || content.essayReplyId;
        _this.annotationId = content.annotationByAnnotationId || content.annotationId;
        _this.commentId = content.commentByCommentId || content.commentId;
        return _this;
    }
    Object.defineProperty(ContentModel.prototype, "behavior", {
        get: function () {
            if (this.textId) {
                return 'text';
            }
            else if (this.imageId) {
                return 'image';
            }
            else if (this.videoId) {
                return 'video';
            }
            return;
        },
        enumerable: true,
        configurable: true
    });
    ContentModel.prototype.isText = function () {
        return !!this.textId;
    };
    ContentModel.prototype.isVideo = function () {
        return !!this.videoId;
    };
    ContentModel.prototype.isImage = function () {
        return !!this.imageId;
    };
    Object.defineProperty(ContentModel.prototype, "text", {
        get: function () {
            return this.getters.textById(this.textId);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContentModel.prototype, "image", {
        get: function () {
            return this.getters.imageById(this.imageId);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContentModel.prototype, "video", {
        get: function () {
            return this.getters.videoById(this.videoId);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContentModel.prototype, "content", {
        get: function () {
            return this.behavior && this[this.behavior];
        },
        enumerable: true,
        configurable: true
    });
    ContentModel.buildLegacyContent = function (contents) {
        return contents.map(function (contentComponent) {
            var content;
            var url;
            var size;
            var origin;
            var description;
            var image;
            var behavior = contentComponent.behavior;
            switch (behavior) {
                case 'text':
                    content = contentComponent.text.body;
                    break;
                case 'video':
                    content = contentComponent.video.providerId;
                    break;
                case 'image':
                    image = contentComponent.image;
                    content = '';
                    url = image.url;
                    size = image.resizeFactor;
                    origin = image.source ? image.source.origin : null;
                    description = image.description;
                    break;
                default:
            }
            return {
                behavior: behavior,
                content: content,
                url: url,
                size: size,
                origin: origin,
                description: description,
            };
        });
    };
    ContentModel.getContentString = function (contents) {
        return contents
            .filter(function (content) { return content.isText(); })
            .map(function (content) { return content.text; })
            .reduce(function (acc, text) { return "" + acc + text.body + "\n"; }, '');
    };
    return ContentModel;
}(Model_1.default));
exports.ContentModel = ContentModel;
